import { MenuItem, MenuItems, MenuItemsProps } from '@headlessui/react';
import { FC, Fragment, ReactNode } from 'react';
import DropdownCore, { TDropdownItem, TDropdownSection } from './DropdownCore';
import DropdownItem from './DropdownItem';

export type { TDropdownItem, TDropdownSection };

export interface DropdownMenuItemProps extends Omit<MenuItemsProps, 'anchor'> {
  items: TDropdownItem[] | TDropdownSection[];
  hasSearch?: boolean;
  // todo: can remove this. if we move away from headlessUI and used FloatingUI directly
  autoClose?: boolean;
  static?: boolean;
  anchor?: 'start' | 'end';
  footer?: ReactNode;
}

const DropdownMenuItems: FC<DropdownMenuItemProps> = (props) => {
  const {
    items,
    hasSearch = false,
    autoClose = true,
    static: _static = false,
    anchor = 'end',
    footer,
    ...rest
  } = props;

  return (
    <MenuItems
      as={Fragment}
      static={_static}
      modal={false}
      portal={true}
      anchor={{ to: `bottom ${anchor}`, gap: 4 }}
      {...rest}
    >
      <DropdownCore
        items={items}
        hasSearch={hasSearch}
        footer={footer}
        renderItem={({ onClick, ...item }, index) => {
          return (
            <MenuItem key={index} disabled={item.disabled}>
              <DropdownItem
                item={item}
                onClick={(event) => {
                  if (!autoClose) {
                    event.preventDefault();
                  }

                  onClick(event);
                }}
              />
            </MenuItem>
          );
        }}
      />
    </MenuItems>
  );
};

export default DropdownMenuItems;
